// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iSVx4","right":"styles_right__3rwLV"};